import { useState, useEffect, useMemo } from "react";
import { Form, Col, Row, Button } from "antd";
import useGet from "../../../global/hooks/useGet";
import usePost from "../../../global/hooks/usePost";
import CustomInput from "../../../global/components/inputWidgets/CustomInput";
import CustomSelect from "../../../global/components/inputWidgets/CustomSelect";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";
import CommonButton from "../../../global/components/CommonButton";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import {
  CheckCircleOutlined,
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import useDelete from "../../../global/hooks/useDelete";
import ConfirmModal from "../../../global/components/ConfirmModal";
import AccountIcon from "../../../assets/images/vectors/SideBarIcons/AccountIcon";
import AccountCreationModal from "../../../global/components/AccountCreationModal";
import OemIcon from "../../../assets/images/vectors/SideBarIcons/OemIcon";
import DealerIcon from "../../../assets/images/vectors/SideBarIcons/DealerIcon";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { useOptions } from "../../../providers/OptionsProvider";
import { getChangedFields } from "../../../utils/getChangedFields";
import usePut from "../../../global/hooks/usePut";

export const AccountForm = ({
  type,
  onCancel,
  isModalForm,
  setDefaultData: setAccountDefaultData,
  defaultData: accountDefaultData,
  disbaleDealerField,
  disableCustomerField,
}) => {
  const { configOptions } = useOptions();
  const loggedInUser = JSON.parse(sessionStorage.getItem("userData"));
  const [selectedOemNo, setSelectedOemNo] = useState(loggedInUser?.oem_no);
  const [selectedDealerNo, setSelectedDealerNo] = useState(
    loggedInUser?.dealer_no,
  );
  const [showModal, setShowModal] = useState(false);
  const [accountType, setAccountType] = useState(loggedInUser?.role_value);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [defaultData, setDefaultData] = useState(
    accountDefaultData
      ? accountDefaultData
      : {
          DealerNo: null,
          OemNo: null,
          CustomerNo: null,
        },
  );
  // console.log(defaultData);
  const [form] = Form.useForm();
  const { id: urlId } = useParams();
  const id = defaultData?.AccountNo ? defaultData?.AccountNo : urlId;
  const navigate = useNavigate();
  const location = useLocation();

  const url = isModalForm
    ? defaultData?.AccountNo
      ? `${process.env.REACT_APP_API_URL}/api/accounts/${id}/`
      : null
    : id
      ? `${process.env.REACT_APP_API_URL}/api/accounts/${id}/`
      : `${process.env.REACT_APP_API_URL}/api/accounts/`;
  const modalPostUrl = `${process.env.REACT_APP_API_URL}/api/accounts/`;

  const dealerOptionsUrl = useMemo(() => {
    const oemNo = defaultData?.OemNo || selectedOemNo;
    return oemNo
      ? `${process.env.REACT_APP_API_URL}/api/dealers/oems/${oemNo}/dealers/`
      : null;
  }, [defaultData?.OemNo, selectedOemNo]);

  const formDealerNo = Form.useWatch("DealerNo", form);
  const isDealerRole = [7, 8, 9].includes(loggedInUser?.role_value);
  const isOemRole = [4, 5, 6].includes(loggedInUser?.role_value);
  const dealerNo = isDealerRole ? loggedInUser?.dealer_no : formDealerNo;
  const getCustomersUrl =
    dealerNo &&
    `${process.env.REACT_APP_API_URL}/api/dealers/${dealerNo}/customers/`;

  const { data: customerData, refetch: customerDataRefetch } =
    useGet(getCustomersUrl);
  function filterRolesByPathname(roles, pathname) {
    if (pathname.includes("oem")) {
      return roles.filter((role) => [4, 5, 6].includes(role.value));
    } else if (pathname.includes("dealer")) {
      return roles.filter((role) => [7, 8, 9].includes(role.value));
    } else if (pathname.includes("customer")) {
      return roles.filter((role) => [10, 11, 12].includes(role.value));
    }
    // default: return all or system roles
    return roles.filter((role) => [2, 3].includes(role.value));
  }
  const modifiedType = getModifiedResponse(configOptions, "roles");
  const filteredRoles = isModalForm
    ? filterRolesByPathname(modifiedType, location.pathname)
    : modifiedType;

  // const modifiedDealer = getModifiedResponse(optionsData, "dealers");
  // const modifiedCustomer = getModifiedResponse(optionsData, "customers");
  const modifiedOems = getModifiedResponse(configOptions, "oems");
  const { data, loading, error, refetch } = useGet(url);
  const {
    data: dealerOp,
    loading: delaerOpLoading,
    error: dealerOpError,
    refetch: delaerOpRefetch,
  } = useGet(dealerOptionsUrl);

  const {
    data: postData,
    loading: postLoading,
    error: postError,
    postData: postAction,
  } = usePost(url);
  const {
    data: postDataModal,
    loading: postLoadingModal,
    error: postErrorModal,
    postData: postActionModal,
  } = usePost(modalPostUrl);

  const {
    data: putData,
    loading: putLoading,
    error: putError,
    putData: putAction,
  } = usePut(url);
  const {
    data: deletedData,
    loading: deletedDataLoading,
    error: deletedDataError,
    deleteData,
  } = useDelete(url);

  const onFinish = (values) => {
    try {
      if (type === "edit") {
        if (
          loggedInUser?.role_value === 10 ||
          loggedInUser?.role_value === 11
        ) {
          const modifiedValues = {
            ...values,
            OemNo: loggedInUser.oem_no,
            DealerNo: loggedInUser.dealer_no,
            CustomerNo: loggedInUser.customer_no,
          };

          const changedFields = getChangedFields(data?.data, modifiedValues);
          changedFields.Password = values.Password;
          putAction(changedFields);
        } else if (
          loggedInUser?.role_value === 7 ||
          loggedInUser?.role_value === 8
        ) {
          const modifiedValues = {
            ...values,
            OemNo: loggedInUser.oem_no,
            DealerNo: loggedInUser.dealer_no,
          };
          const changedFields = getChangedFields(data?.data, modifiedValues);
          changedFields.Password = values.Password;
          putAction(changedFields);
        } else if (
          loggedInUser?.role_value === 4 ||
          loggedInUser?.role_value === 5
        ) {
          const modifiedValues = {
            ...values,
            OemNo: loggedInUser.oem_no,
          };
          const changedFields = getChangedFields(data?.data, modifiedValues);
          changedFields.Password = values.Password;
          putAction(changedFields);
        } else {
          const changedFields = getChangedFields(data?.data, values);
          changedFields.Password = values.Password;
          putAction(changedFields);
        }
      } else {
        if (isModalForm) {
          const modifiedValues = ![4, 5, 6, 7, 8, 9].includes(
            loggedInUser?.role_value,
          )
            ? {
                ...values,
              }
            : {
                ...values,
                DealerNo: defaultData?.DealerNo,
                OemNo: defaultData?.OemNo,
              };

          return postActionModal(modifiedValues);
        }
        if (
          loggedInUser?.role_value === 10 ||
          loggedInUser?.role_value === 11
        ) {
          const modifiedValues = {
            ...values,
            OemNo: loggedInUser.oem_no,
            DealerNo: loggedInUser.dealer_no,
            CustomerNo: loggedInUser.customer_no,
          };
          postAction(modifiedValues);
        } else if (
          loggedInUser?.role_value === 7 ||
          loggedInUser?.role_value === 8
        ) {
          const modifiedValues = {
            ...values,
            OemNo: loggedInUser.oem_no,
            DealerNo: loggedInUser.dealer_no,
          };
          postAction(modifiedValues);
        } else if (
          loggedInUser?.role_value === 4 ||
          loggedInUser?.role_value === 5
        ) {
          const modifiedValues = {
            ...values,
            OemNo: loggedInUser?.oem_no,
          };
          postAction(modifiedValues);
        } else {
          postAction(values);
        }
      }
    } catch (error) {
      console.log(error);
      openErrorNotification("Something went wrong");
    }
  };

  const onReset = () => {
    isModalForm && form.resetFields();
    onCancel ? onCancel() : navigate(-1);
  };

  const onDeleteConfirm = async () => {
    try {
      await deleteData();
    } catch (error) {
      openErrorNotification("Failed!");
    }
    setShowModal(false);
  };

  // useEffect(() => {
  //   delaerOpRefetch();
  // }, [selectedOemNo]);

  useEffect(() => {
    if (!id || loading) return;
    const getAccountInfoById = () => {
      form.resetFields();
      try {
        if (data?.data) {
          form.setFieldsValue({
            UserId: data?.data?.UserId ? String(data?.data?.UserId) : "",
            AccountName: data.data.AccountName
              ? String(data.data.AccountName)
              : "",
            AccountDesc: data.data.AccountDesc
              ? String(data.data.AccountDesc)
              : "",
            Email: data.data.Email ? String(data.data.Email) : "",
            AccountType: data.data.AccountType ? data.data.AccountType : "",
            OemNo: data.data.OemNo ? Number(data.data.OemNo) : "",
            DealerNo: data.data.DealerNo ? data.data.DealerNo : "",
            CustomerNo: data.data.CustomerNo ? data.data.CustomerNo : "",
          });
          setAccountType(data.data.AccountType);
          setSelectedOemNo(data.data.OemNo);
          setSelectedDealerNo(data.data.DealerNo);
          setDefaultData((prev) => ({
            ...prev,
            OemNo: data.data.OemNo,
            DealerNo: data.data.DealerNo,
            CustomerNo: data.data.CustomerNo,
          }));
        } else {
          console.warn("No data found for the given ID");
        }
      } catch (error) {
        if (!loading) {
          openErrorNotification("Error fetching data!");
        }
      }
    };

    getAccountInfoById();
  }, [id, data, loading, form, type]);

  //toat for create
  useEffect(() => {
    if (postError) {
      openErrorNotification(
        postError?.response?.data?.message || "Something went wrong",
      );
    } else if (!postLoading && !postError && postData) {
      openConfirmNotification("Success");

      setTimeout(() => {
        navigate(-1);
      }, 400);
    }
  }, [postError, postData, postLoading]);
  //toat for create
  useEffect(() => {
    if (postErrorModal) {
      openErrorNotification(
        postErrorModal?.response?.data?.message || "Something went wrong",
      );
    } else if (!postLoadingModal && !postErrorModal && postDataModal) {
      openConfirmNotification("Success");

      setTimeout(() => {
        onCancel();
      }, 400);
    }
  }, [postErrorModal, postDataModal, postLoadingModal]);

  //toat for update
  useEffect(() => {
    if (putError) {
      openErrorNotification(
        putError?.response?.data?.message || "Something went wrong",
      );
    } else if (!putLoading && !putError && putData) {
      openConfirmNotification("Success");

      refetch();
      setTimeout(() => {
        if (defaultData?.AccountNo) {
          onCancel();
        } else {
          navigate(-1);
        }
      }, 100);
    }
  }, [putData, putLoading, putError]);

  useEffect(() => {
    if (deletedData && !deletedDataError) {
      openConfirmNotification("Success");
      // refetch();
      navigate("/account");
    } else if (deletedDataError) {
      openErrorNotification(
        deletedDataError?.response?.data?.message || "Something went wrong",
      );
    }
  }, [deletedData, deletedDataError]);

  const breadcrumbItems = [
    {
      label: "Account",
      href: "/account",
    },
    {
      label: id ? (type === "info" ? "Information" : "Edit") : "Add",
      href: id
        ? type === "info"
          ? `/account/info/${id}`
          : `/account/edit/${id}`
        : "/account/add",
    },
  ];

  const buttonsData =
    type === "info"
      ? [
          {
            label: "Edit",
            icon: <EditOutlined />,
            onClick: () => {
              navigate(`/account/edit/${id}`);
            },
          },
          {
            label: "Delete",
            icon: <DeleteOutlined />,
            onClick: () => {
              setShowModal(true);
            },
          },
          {
            label: "List",
            icon: <UnorderedListOutlined />,
            onClick: () => {
              navigate(-1);
            },
          },
        ]
      : [
          {
            label: "Apply",
            icon: <CheckCircleOutlined />,
            onClick: () => form.submit(),
          },
          {
            label: "Cancel",
            icon: <CloseOutlined />,
            onClick: onReset,
          },
        ];

  const handleCreateNew = (type) => {
    setModalType(type);
    setIsOpenModal(true);
  };
  useEffect(() => {
    // delaerOpRefetch();
    // customerDataRefetch();
    if (defaultData) {
      form.setFieldsValue(defaultData);
    }
  }, [defaultData]);

  return (
    <div>
      <AccountCreationModal
        isOpenModal={isOpenModal}
        modalType={modalType}
        setIsOpenModal={setIsOpenModal}
        setDefaultData={setDefaultData}
        defaultData={defaultData}
        setModalType={setModalType}
        isModal={true}
        isModalForm={true}
        title={
          <div className="flex items-center bg-gray-200 p-2 rounded-md">
            {modalType === "OEM" ? (
              <OemIcon className="text-[15px] text-black ml-1" />
            ) : modalType === "Dealer" ? (
              <DealerIcon className="text-[15px] text-black ml-1" />
            ) : modalType === "Customer" ? (
              <AccountIcon className="text-[15px] text-black ml-1" />
            ) : null}
            <span className="text-[14px] font-[Poppins] text-black  ml-2">
              {isOpenModal ? `Add ${modalType}` : "Send Invitation"}
            </span>
          </div>
        }
      />

      <Form
        validateTrigger={"onChange"}
        form={form}
        onFinish={onFinish}
        scrollToFirstError
        layout={"vertical"}
        autoComplete={"off"}
      >
        <div>
          {!isModalForm && (
            <div className="pb-4 sticky -mt-4 pt-[6px] top-[55px] z-10 bg-[#f4f5f9]">
              <CommonBreadcrumb breadcrumbItems={breadcrumbItems}>
                <CommonButton buttonsData={buttonsData} />
              </CommonBreadcrumb>
            </div>
          )}
          {
            <div
              className={`bg-white overflow-hidden ${
                isModalForm ? "" : "border rounded-[4px]"
              }`}
            >
              {!isModalForm && (
                <div className="flex items-center bg-gray-200 p-2.5">
                  <AccountIcon className="text-[18px] text-black " />
                  <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                    Account
                  </span>
                </div>
              )}
              <div className="px-2 pt-1 pb-3">
                <Row gutter={[16, 8]}>
                  <Col
                    xs={!isModalForm && 24}
                    sm={!isModalForm && 24}
                    md={!isModalForm && 12}
                    lg={!isModalForm && 12}
                    xl={!isModalForm && 12}
                    span={24}
                  >
                    <CustomInput
                      label="Username"
                      name="UserId"
                      disabled={type === "info"}
                      autoComplete="off"
                      required
                      loading={loading}
                    />
                  </Col>
                  {type !== "info" && (
                    <Col
                      xs={!isModalForm && 24}
                      sm={!isModalForm && 24}
                      md={!isModalForm && 12}
                      lg={!isModalForm && 12}
                      xl={!isModalForm && 12}
                      span={24}
                    >
                      <CustomInput
                        label="Password"
                        name="Password"
                        type="password"
                        disabled={type === "info"}
                        autoComplete="new-password"
                        required={!id || !defaultData?.AccountNo}
                        loading={loading}
                      />
                    </Col>
                  )}
                  {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Name"
                        name="AccountName"
                        disabled={type === "info"}
                        required
                      />
                    </Col> */}
                  <Col
                    xs={!isModalForm && 24}
                    sm={!isModalForm && 24}
                    md={!isModalForm && 12}
                    lg={!isModalForm && 12}
                    xl={!isModalForm && 12}
                    span={24}
                  >
                    <CustomInput
                      label="Description"
                      name="AccountDesc"
                      disabled={type === "info"}
                      loading={loading}
                    />
                  </Col>
                  <Col
                    xs={!isModalForm && 24}
                    sm={!isModalForm && 24}
                    md={!isModalForm && 12}
                    lg={!isModalForm && 12}
                    xl={!isModalForm && 12}
                    span={24}
                  >
                    <CustomInput
                      label="Email"
                      name="Email"
                      type="email"
                      isEmail={true}
                      disabled={type === "info"}
                      required
                      loading={loading}
                    />
                  </Col>
                  <Col
                    xs={!isModalForm && 24}
                    sm={!isModalForm && 24}
                    md={!isModalForm && 12}
                    lg={!isModalForm && 12}
                    xl={!isModalForm && 12}
                    span={24}
                  >
                    <CustomSelect
                      label="Account Type"
                      name="AccountType"
                      options={filteredRoles}
                      placeholder="Please select"
                      onChange={(value) => {
                        setAccountType(value);
                        if (isModalForm) {
                          return;
                        }
                        form.setFieldsValue({
                          OemNo: "",
                          DealerNo: "",
                          CustomerNo: "",
                        });

                        if (isOemRole) {
                          setSelectedOemNo(loggedInUser?.oem_no);
                        } else {
                          setSelectedOemNo("");
                        }
                        if (isDealerRole) {
                          setSelectedDealerNo(loggedInUser?.dealer_no);
                        } else {
                          setSelectedDealerNo("");
                        }
                        setDefaultData((prev) => ({
                          ...prev,
                          OemNo: "",
                          DealerNo: "",
                          CustomerNo: "",
                        }));
                      }}
                      disabled={type === "info"}
                      required
                      loading={loading}
                    />
                  </Col>
                  {![1, 2, 3].includes(accountType) &&
                    [1, 2].includes(loggedInUser?.role_value) && (
                      <Col
                        xs={!isModalForm && 24}
                        sm={!isModalForm && 24}
                        md={!isModalForm && 12}
                        lg={!isModalForm && 12}
                        xl={!isModalForm && 12}
                        span={24}
                      >
                        {/* <CustomSelect
                            label="OEM"
                            name="OemNo"
                            options={modifiedOems}
                            placeholder="Please select"
                            onChange={(value) => {
                              setSelectedOemNo(value);
                              form.setFieldsValue({
                                DealerNo: "",
                              });
                            }}
                            disabled={type === "info"}
                            required
                            handleCreateNew={handleCreateNew}
                            type={"OEM"}
                          /> */}
                        <CustomSelect
                          label="OEM"
                          name="OemNo"
                          options={modifiedOems}
                          disabled={type === "info" || isModalForm}
                          placeholder="Please select"
                          onChange={(value) => {
                            setDefaultData((prev) => ({
                              ...prev,
                              OemNo: value,
                              DealerNo: "",
                              CustomerNo: "",
                            }));
                            setSelectedOemNo(value);
                            form.setFieldsValue({
                              DealerNo: "",
                              CustomerNo: "",
                            });
                          }}
                          required
                          handleCreateNew={handleCreateNew}
                          type={"OEM"}
                          loading={loading}
                        />
                      </Col>
                    )}
                  {[7, 8, 9, 10, 11, 12].includes(accountType) &&
                  [1, 2, 4, 5].includes(loggedInUser?.role_value) ? (
                    <Col
                      xs={!isModalForm && 24}
                      sm={!isModalForm && 24}
                      md={!isModalForm && 12}
                      lg={!isModalForm && 12}
                      xl={!isModalForm && 12}
                      span={24}
                    >
                      {/* <CustomSelect
                            label="Dealer"
                            name="DealerNo"
                            options={
                              dealerOp?.data?.map((item) => ({
                                label: item.name,
                                value: item.value,
                              })) || []
                            }
                            placeholder="Please select"
                            disabled={type === "info"}
                            required
                            handleCreateNew={handleCreateNew}
                            type={"Dealer"}
                          /> */}
                      <CustomSelect
                        label="Dealer"
                        name="DealerNo"
                        disabled={
                          type === "info"
                            ? type === "info"
                            : isModalForm
                              ? isModalForm
                              : disbaleDealerField
                                ? disbaleDealerField
                                : defaultData?.OemNo
                                  ? !defaultData?.OemNo
                                  : !selectedOemNo
                        }
                        onChange={(value) => {
                          setDefaultData((prev) => ({
                            ...prev,
                            DealerNo: value,
                            CustomerNo: "",
                          }));
                          setSelectedDealerNo(value);
                          form.setFieldsValue({
                            CustomerNo: "",
                          });
                        }}
                        options={
                          dealerOp?.data?.map((item) => ({
                            label: item.name,
                            value: item.value,
                          })) || []
                        }
                        placeholder="Please select"
                        required
                        handleCreateNew={handleCreateNew}
                        type={"Dealer"}
                        loading={loading}
                      />
                    </Col>
                  ) : null}
                  {[10, 11, 12].includes(accountType) &&
                    [1, 2, 3, 4, 5, 6, 7, 8, 9].includes(
                      loggedInUser?.role_value,
                    ) && (
                      <Col
                        xs={!isModalForm && 24}
                        sm={!isModalForm && 24}
                        md={!isModalForm && 12}
                        lg={!isModalForm && 12}
                        xl={!isModalForm && 12}
                        span={24}
                      >
                        {/* <CustomSelect
                            label="Customer"
                            name="CustomerNo"
                            options={
                              customerData?.data?.map((item) => ({
                                label: item.name,
                                value: item.value,
                              })) || []
                            }
                            placeholder="Please select"
                            disabled={type === "info"}
                            required
                            handleCreateNew={handleCreateNew}
                            type={"Customer"}
                          /> */}
                        {/* {console.log("defaultData?.DealerNo", defaultData)} */}
                        <CustomSelect
                          disabled={
                            // defaultData?.OemNo && defaultData?.DealerNo
                            //   ? !defaultData?.OemNo || !defaultData?.DealerNo
                            //   : !selectedOemNo ||
                            //     !selectedDealerNo ||
                            type === "info"
                              ? type === "info"
                              : isModalForm
                                ? isModalForm
                                : disableCustomerField
                                  ? disableCustomerField
                                  : defaultData?.DealerNo
                                    ? !defaultData?.DealerNo
                                    : !selectedDealerNo
                          }
                          label="Customer"
                          name="CustomerNo"
                          options={
                            customerData?.data?.map((item) => ({
                              label: item.name,
                              value: item.value,
                            })) || []
                          }
                          placeholder="Please select"
                          required
                          handleCreateNew={handleCreateNew}
                          type={"Customer"}
                          loading={loading}
                        />
                      </Col>
                    )}
                </Row>
              </div>
            </div>
          }
        </div>
      </Form>

      {isModalForm && (
        <div className="flex justify-center space-x-2 mt-2.5">
          <Button
            type="primary"
            className="mr-2 min-w-[104px] h-[30px] py-1 px-[10px] font-medium flex items-center "
            onClick={() => form.submit()}
            loading={postLoadingModal || putLoading}
          >
            <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
            <span className="">Apply</span>
          </Button>
          <Button className="reset-button" onClick={onReset}>
            <CloseOutlined />
            <span className="">Cancel</span>
          </Button>
        </div>
      )}
      <ConfirmModal
        showModal={showModal}
        setShowModal={setShowModal}
        onDeleteConfirm={onDeleteConfirm}
      />
    </div>
  );
};
